import React, { useState } from 'react';
import { Phone, Menu, X } from 'lucide-react';
import { companyInfo } from '../mockData';
import { Button } from './ui/button';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo and Company Name */}
          <div className="flex items-center space-x-3">
            <img 
              src="/logo-flagpoles.png" 
              alt="Eagle Angel Flags Logo" 
              className="h-16 w-auto object-contain"
            />
            <div>
              <h1 className="text-xl font-bold text-blue-900">{companyInfo.name}</h1>
              <p className="text-xs text-gray-600">{companyInfo.location}</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-blue-800 transition-colors font-medium">
              Services
            </button>
            <button onClick={() => scrollToSection('installations')} className="text-gray-700 hover:text-blue-800 transition-colors font-medium">
              Installations
            </button>
            <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-blue-800 transition-colors font-medium">
              About
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-blue-800 transition-colors font-medium">
              Contact
            </button>
          </nav>

          {/* Phone Number */}
          <div className="hidden lg:flex items-center space-x-2">
            <a href={`tel:${companyInfo.phoneRaw}`} className="flex items-center space-x-2 bg-red-600 hover:bg-red-700 text-white px-5 py-2.5 rounded-lg transition-colors font-medium">
              <Phone className="w-4 h-4" />
              <span>{companyInfo.phone}</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 text-gray-700 hover:text-blue-800"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <nav className="px-4 py-4 space-y-3">
            <button onClick={() => scrollToSection('services')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 rounded-lg transition-colors">
              Services
            </button>
            <button onClick={() => scrollToSection('installations')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 rounded-lg transition-colors">
              Installations
            </button>
            <button onClick={() => scrollToSection('about')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 rounded-lg transition-colors">
              About
            </button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 rounded-lg transition-colors">
              Contact
            </button>
            <a href={`tel:${companyInfo.phoneRaw}`} className="flex items-center justify-center space-x-2 bg-red-600 text-white px-4 py-2 rounded-lg mt-4">
              <Phone className="w-4 h-4" />
              <span>{companyInfo.phone}</span>
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;